import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injectable, ViewEncapsulation, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule, formatDate } from '@angular/common';
import { CreateReminderDialogService } from './create-reminder-dialog.service';
import { snackbarService } from '@one/web-components';
import { AppUtils } from '../../utlis/app-utils';
import { ReminderTableComponent } from '../../create-notification/due-date-reminder/reminder-table/reminder-table.component';
import { ReminderMessageTempleteDialogComponent } from '../../create-notification/due-date-reminder/create-reminder/reminder-message-templete-dialog/reminder-message-templete-dialog.component';
import { ReminderTablePopupComponent } from './reminder-table-popup/reminder-table-popup.component';
import { ReminderMessageTempleteDialogPopupComponent } from './create-reminder-popup/reminder-message-templete-dialog/reminder-message-templete-dialog-popup.component';

export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
}

@Component({
  selector: 'dl-due-date-reminder-popup',
  standalone: true,
  imports: [OneWebComponentsAngularModule, ReminderTablePopupComponent, CommonModule, ReactiveFormsModule, FormsModule, ReminderMessageTempleteDialogPopupComponent],
  templateUrl: './due-date-reminder-popup.component.html',
  styleUrl: './due-date-reminder-popup.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DueDateReminderPopupComponent implements OnInit, OnChanges {

  @Input() dialogData?: any; // Optional - only used when component is in modal mode
   @Output() closeDialog = new EventEmitter<any>(); // Optional - only used when component is in modal mode
 
   reminderVisible: any;
   dateFormate: string;
   public constructor(
     private changeDetectorRef: ChangeDetectorRef,
     private createReminderDialogService: CreateReminderDialogService,
     private _QnSbnDataService: QnSbnDataServiceService,
     private qnsbnservice: QnSbnService,
     private appUtils: AppUtils
   ) {
     this._QnSbnDataService.DueDateEnabled$.subscribe(
       res => {
         this.DueDateEnabled = res;
       }
     )
     this._QnSbnDataService.FeedbackEnabled$.subscribe(
       res => {
         this.feedbackEnabled = res;
       }
     )
   }
 
   public remindersColumn = ['reminderDate', 'reminderSubject', 'reminderMessage', 'reminderSendMode', 'reminderActionIcons'];
   public remindersData = [];
   public DueDateEnabled: boolean;
   public feedbackEnabled: boolean;
   public feedbackDueDate = new FormControl<Date | null>(null); // Initialize with null, not a date
   public notificationData: any;
   public notificationId: string;
   public showDueDateSaveButton: boolean = false;
   public originalDueDate: Date | null = null;
   public wasDisabledAndSaved: boolean = false; // Track if toggle was disabled and saved
   public addMoreReminders: Subject<any> = new Subject<any>();
   public data: {
     tableData: any[],
     columnData: string[],
     feedbackDueDate: Date | null,
     spinnerBool: boolean,
     existingReminders?: any[],
     notificationData?: any
   } = {
       tableData: [],
       columnData: [],
       feedbackDueDate: null, // Don't initialize with current date
       spinnerBool: false,
       existingReminders: []
     }
 
   public feedbackDueDateFilter = (d: Date | null): boolean => {
     const startDate = d || new Date();
     return startDate <= new Date();
   }
 
   public setDateFilter(value: number): void {
     const nextDueDate = new Date();
     nextDueDate.setDate(nextDueDate.getDate() + value);
     this.feedbackDueDate.setValue(nextDueDate);
   }
 
   public ngOnChanges(changes: SimpleChanges): void {
 
     if (changes['dialogData'] && changes['dialogData'].currentValue && this.dialogData) {
       this.initializeFromDialogData(changes['dialogData'].currentValue);
     }
   }
 
   private initializeFromDialogData(data: any): void {
    
     if (data) {
       // Set notification data first - this is important for API calls
       if (data.notificationData) {
         this.notificationData = data.notificationData;
        
       }

       // Set notification ID
       if (data.notificationId) {
         this.notificationId = data.notificationId;
       }

       // Set due date from dialog data or from notificationData
       if (data.feedbackDueDate) {
         const parsedDate = new Date(data.feedbackDueDate);
         this.feedbackDueDate.setValue(parsedDate);
         this.originalDueDate = new Date(data.feedbackDueDate);
         // Sync the service so child components (edit reminder) get the correct due date
         this.createReminderDialogService.setFeedbackDueDate(parsedDate);
       } else if (this.notificationData?.FeedbackDueDate) {
         const parsedDate = new Date(this.notificationData.FeedbackDueDate);
         this.feedbackDueDate.setValue(parsedDate);
         this.originalDueDate = new Date(this.notificationData.FeedbackDueDate);
         // Sync the service so child components (edit reminder) get the correct due date
         this.createReminderDialogService.setFeedbackDueDate(parsedDate);
       }
 
       // Set reminders from dialog data
       if (data.reminders && Array.isArray(data.reminders) && data.reminders.length > 0) {
         this.remindersData = data.reminders;
         // Update the service with reminders data for duplicate checking
         this.createReminderDialogService.setRemindersDate(this.remindersData as any);
         // Force change detection so the *ngIf creates the child reminder-table-popup
         // component (and it subscribes to addMoreReminders) BEFORE we emit.
         this.changeDetectorRef.detectChanges();
         this.addMoreReminders.next(this.remindersData);
         
       }
 
       // Set other properties
       if (data.dueDateEnabled !== undefined) {
         this.DueDateEnabled = data.dueDateEnabled;
       } else if (this.notificationData?.DueDateEnabled !== undefined) {
         this.DueDateEnabled = this.notificationData.DueDateEnabled;
       }
 
       if (data.feedbackEnabled !== undefined) {
         this.feedbackEnabled = data.feedbackEnabled;
       } else if (this.notificationData?.FeedbackEnabled !== undefined) {
         this.feedbackEnabled = this.notificationData.FeedbackEnabled;
       }
     }
   }
 
   public ngOnInit(): void {
     // Only reset reminders if not in dialog mode (i.e., not opened from notification-details)
     if (!this.dialogData) {
       this.createReminderDialogService.setRemindersDate([]);
     }
    
     if (this.dialogData) {
       this.initializeFromDialogData(this.dialogData);
       this.changeDetectorRef.detectChanges();
     }
 
     
     this._QnSbnDataService.mappingData$.subscribe(observer => {
       if (!this.dialogData) {
         
         if (!this._QnSbnDataService.isEmpty(observer['feedbackDueDate'])) {
           const dueDateValue = observer['feedbackDueDate']['feedbackDueDate'];
          

           if (dueDateValue) {

             let dateToSet: Date | null = null;

             if (dueDateValue instanceof Date) {
               dateToSet = dueDateValue;
             } else if (typeof dueDateValue === 'string') {
               dateToSet = new Date(dueDateValue);

               if (isNaN(dateToSet.getTime())) {

                 dateToSet = null;
               }
             }

             if (dateToSet && !isNaN(dateToSet.getTime())) {

               this.feedbackDueDate.setValue(dateToSet, { emitEvent: false });

             }
           }
         }

         // Handle reminders
         if (!this._QnSbnDataService.isEmpty(observer['notificationReminders'])) {
           this.remindersData = observer['notificationReminders']['remindersData'];
           // Update the service with reminders data for duplicate checking
           this.createReminderDialogService.setRemindersDate(this.remindersData as any);
           this.addMoreReminders.next(this.remindersData);
         }

         this.changeDetectorRef.detectChanges();
         
         // Only update notificationData from service if NOT in dialog mode
         if (!this._QnSbnDataService.isEmpty(observer['localNotificationId'])) {
           this.notificationData = observer['localNotificationId'];
         }
       }
     });
   }
 
   ngOnDestroy(): void {
     this.addProduct(this.feedbackDueDate.value, this.remindersData);
   }
 
   public getFeedbackDueDate(fdd: Date): void {
 
     if (!fdd) {
       return;
     }

     // Keep the service in sync so edit-reminder gets the latest due date
     this.createReminderDialogService.setFeedbackDueDate(new Date(fdd));
 
     this.dateFormate = this.appUtils.formatDateString(fdd);
 
     // Show Save button if date changed from original
     if (this.originalDueDate) {
       const newDate = new Date(fdd);
       newDate.setHours(0, 0, 0, 0);
       const origDate = new Date(this.originalDueDate);
       origDate.setHours(0, 0, 0, 0);
       this.showDueDateSaveButton = newDate.getTime() !== origDate.getTime();
     } else {
       this.showDueDateSaveButton = true;
     }
 
     this._QnSbnDataService.getMappedQnsbnData({
       "feedbackDueDate": this.dateFormate
     }, "FeedbackDueDate");
 
     this.changeDetectorRef.detectChanges();
   }

   public saveDueDateChange(): void {
     const notificationId = this.notificationId || this.notificationData?.NotificationId;
     
     if (!notificationId) {
       this.snackBarMessage('negative', 'Cannot save: Notification ID not found');
       return;
     }

     // Fix timezone issue: set time to noon to avoid date shifting when converting to UTC
     let feedbackDueDateISO: string | null = null;
     if (this.feedbackDueDate.value) {
       const dateWithNoon = new Date(this.feedbackDueDate.value);
       dateWithNoon.setHours(12, 0, 0, 0);
       feedbackDueDateISO = dateWithNoon.toISOString();
     }

     const payload = {
       NotificationId: notificationId,
       FeedbackDueDate: feedbackDueDateISO,
       DueDateEnabled: this.DueDateEnabled,
       NotficationReminders: [] // Empty array - not modifying reminders, just due date
     };

    

     this.qnsbnservice.createReminders(payload).subscribe({
       next: (response) => {
       
         this.snackBarMessage('positive', 'Due date saved successfully');
         this.originalDueDate = this.feedbackDueDate.value;
         this.showDueDateSaveButton = false;
         this.changeDetectorRef.detectChanges();
       },
       error: (error: HttpErrorResponse) => {
       
         this.qnsbnservice.httpErrorHandler(error, 'Could not save due date.');
       }
     });
   }
 
   public addProduct(newDate, reminderData) {
     this._QnSbnDataService.getMappedQnsbnData({
       "feedbackDueDate": newDate
     }, "FeedbackDueDate");
     this._QnSbnDataService.getMappedQnsbnData({
       "remindersData": reminderData
     }, "NotificationReminders");
   }
 
   public openReminderTemplateDialog(): void {
    
     
     this.qnsbnservice.getReminderTemplate(this.notificationData?.Type, this.notificationData?.LocalNotificationLanguage).subscribe(
       (data: any) => {
    

         this.reminderVisible = true;
         if (data.errorMessage) {
           this.snackBarMessage('alarm', data.errorMessage.errorMessage);
         } else {
           this.displayRemainderTemplateDialog(data.MessageTemplates);
         }
       },
       (error: HttpErrorResponse) => {
        
         this.qnsbnservice.httpErrorHandler(error, 'Could not fetch message templates.');
       }
     );
   }
 
   public displayRemainderTemplateDialog(tempData) {

    
     this.reminderVisible = true;
     const tableColumnData = ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'];
     this.data = {
       tableData: tempData,
       columnData: tableColumnData,
       feedbackDueDate: this.feedbackDueDate.value,
       spinnerBool: true,
       existingReminders: this.remindersData,
       notificationData: this.notificationData
     };

     

     this.changeDetectorRef.detectChanges();

   }
 
   public onReminderDialogClose(event: any): void {
     this.reminderVisible = false;
 
     if (!event?.data) {
       this.addMoreReminders.next(this.remindersData);
       return;
     }
 
     const updatedReminders = event.data.map(item => ({
       ...item,
       reminderActionIcons: true,
       reminderSubject: item.reminderSubject || item.templateDetails?.templateSubject || '',
       reminderMessage: item.reminderMessage || item.templateDetails?.templateBody || '',
       templateDetails: {
         templateSubject: item.reminderSubject || item.templateDetails?.templateSubject || '',
         templateBody: item.reminderMessage || item.templateDetails?.templateBody || ''
       }
     }));
 
     this.remindersData = [...this.remindersData, ...updatedReminders];
 
     // Update the service with current reminders data for duplicate checking
     this.createReminderDialogService.setRemindersDate(this.remindersData as any);
 
     this.addMoreReminders.next(this.remindersData);
 
     this.changeDetectorRef.detectChanges();
   }

   public onTableDataChange(updatedData: any[]): void {
     this.remindersData = updatedData;
     // Update the service with current reminders data for duplicate checking
     this.createReminderDialogService.setRemindersDate(this.remindersData as any);
     this.changeDetectorRef.detectChanges();
   }
 
 
   public updateEnabled(toggle) {
     this._QnSbnDataService.DueDateEnabled$.next(toggle);
     
     // When toggling ON after it was disabled and saved, reset to fresh state
     // Keep only sent reminders
     if (toggle === true && this.wasDisabledAndSaved) {
       // Clear the due date
       this.feedbackDueDate.setValue(null);
       this.originalDueDate = null;
       this.showDueDateSaveButton = false;
       
       // Keep only sent reminders (reminderSendStatus === 'Sent')
       const sentReminders = this.remindersData.filter(reminder => 
         reminder.reminderSendStatus === 'Sent' || reminder.reminderSendStatus === 'sent'
       );
       this.remindersData = sentReminders;
       this.createReminderDialogService.setRemindersDate(this.remindersData as any);
       this.addMoreReminders.next(this.remindersData);
       
       // Reset the flag
       this.wasDisabledAndSaved = false;
     }

     // Always trigger change detection so the view updates immediately
     // (OnPush strategy requires manual detectChanges for ngIf conditions)
     this.changeDetectorRef.detectChanges();
   }
 
   snackBarMessage(status: any, message: string) {
     snackbarService.show({
       message: message,
       snackbarProps: {
         status: status,
         direction: 'horizontal',
         showClose: true,
         elevated: false,
         duration: 5000,
         verticalPlacement: 'top',
         horizontalPlacement: 'right',
       }
     });
   }
 
   public saveAndClose(): void {
     // Get the notification ID from either the input or the notification data
     const notificationId = this.notificationId || this.notificationData?.NotificationId;
     
     // Proceed with API call if we have a notificationId AND either:
     // - DueDateEnabled is false (user is disabling due date), OR
     // - There are reminders to save
     if (notificationId && (!this.DueDateEnabled || this.remindersData.length > 0)) {
       
       if (!this.DueDateEnabled) {
         // --- DISABLING DUE DATE FLOW ---
         // When disabling, we perform two sequential API calls:
         // 1. First, delete all unsent reminders via createReminders API with DeleteReminder payload
         // 2. Then, disable the due date via createReminders API with empty values

         // Filter out reminders that have already been sent (they cannot be deleted)
         const unsentReminders = this.remindersData.filter(reminder => 
           reminder.reminderSendStatus !== 'Sent' && reminder.reminderSendStatus !== 'sent'
         );
         
         if (unsentReminders.length > 0) {
           // Step 1: Call createReminders API with DeleteReminder payload to remove unsent reminders
           const deletePayload = {
             NotificationId: notificationId,
             FeedbackDueDate: this.feedbackDueDate.value ? new Date(this.feedbackDueDate.value).toISOString() : null,
             DueDateEnabled: true,
             DeleteReminder: unsentReminders.map(reminder => ({
               ReminderId: reminder.reminderId || reminder.ReminderId
             }))
           };
           
           this.qnsbnservice.createReminders(deletePayload).subscribe({
             next: () => {
               // Step 2: After successful deletion, call API again to disable due date with empty values
               this.disableDueDateAndClose(notificationId);
             },
             error: (error: HttpErrorResponse) => {
               this.qnsbnservice.httpErrorHandler(error, 'Could not delete reminders.');
               this.emitCloseDialog();
             }
           });
         } else {
           // No unsent reminders to delete, skip to Step 2: disable due date directly
           this.disableDueDateAndClose(notificationId);
         }
       } else {
         // --- SAVING REMINDERS FLOW ---
         // DueDateEnabled is true: save the due date and any reminders via a single API call

         // Build the feedback due date ISO string, set to noon to avoid timezone date-shift issues
         let feedbackDueDateISO: string = '';
         if (this.feedbackDueDate.value) {
           const dateWithNoon = new Date(this.feedbackDueDate.value);
           dateWithNoon.setHours(12, 0, 0, 0);
           feedbackDueDateISO = dateWithNoon.toISOString();
         }

         // Build the payload with notification info and reminders
         const payload: any = {
           NotificationId: notificationId,
           FeedbackDueDate: feedbackDueDateISO,
           DueDateEnabled: this.DueDateEnabled,
           NotficationReminders: [] // Empty array — reminders included separately in Reminders key
         };

         // Map reminders data into the payload format expected by the API
         if (this.remindersData.length > 0) {
           payload.Reminders = this.remindersData.map(reminder => ({
             ReminderDate: reminder.reminderDate,
             ReminderSubject: reminder.reminderSubject,
             ReminderMessage: reminder.reminderMessage,
             ReminderSendMode: reminder.reminderSendMode
           }));
         }

         // Call createReminders API to save due date and reminders
         this.qnsbnservice.createReminders(payload).subscribe({
           next: () => {
             this.snackBarMessage('positive', 'Reminders saved successfully');
             this.emitCloseDialog();
           },
           error: (error: HttpErrorResponse) => {
             this.qnsbnservice.httpErrorHandler(error, 'Could not save changes.');
             this.emitCloseDialog();
           }
         });
       }
     } else {
       // No notificationId or nothing to save — just close the dialog
       this.emitCloseDialog();
     }
   }

   private disableDueDateAndClose(notificationId: string): void {
     const payload: any = {
       NotificationId: notificationId,
       FeedbackDueDate: '',
       DueDateEnabled: false,
       NotficationReminders: []
     };

     this.qnsbnservice.createReminders(payload).subscribe({
       next: () => {
         this.snackBarMessage('positive', 'Due date disabled successfully');
         this.wasDisabledAndSaved = true;
         // Clear unsent reminders locally
         const sentReminders = this.remindersData.filter(reminder => 
           reminder.reminderSendStatus === 'Sent' || reminder.reminderSendStatus === 'sent'
         );
         this.remindersData = sentReminders;
         this.feedbackDueDate.setValue(null);
         this.originalDueDate = null;
         this.createReminderDialogService.setRemindersDate(this.remindersData as any);
         this.addMoreReminders.next(this.remindersData);
         this.changeDetectorRef.detectChanges();
         this.emitCloseDialog();
       },
       error: (error: HttpErrorResponse) => {
         this.qnsbnservice.httpErrorHandler(error, 'Could not save changes.');
         this.emitCloseDialog();
       }
     });
   }

   private emitCloseDialog(): void {
     this.addProduct(this.feedbackDueDate.value, this.remindersData);

     if (this.dialogData) {
       const result = {
         reminders: this.remindersData,
         feedbackDueDate: this.feedbackDueDate.value,
         dueDateEnabled: this.DueDateEnabled,
         feedbackEnabled: this.feedbackEnabled
       };
       this.closeDialog.emit(result);
     }
   }
 
   public cancelAndClose(): void {
     if (this.dialogData) {
       this.closeDialog.emit(null);
     }
   }

   public closePopup(): void {
     // Just close the popup without calling any APIs
     this.emitCloseDialog();
   }
 
 }
 